/** @format */

import { ServiceBagVoucher } from './services'

import { setGlobal } from 'reactn'

export default function BagVoucher() {
	const handleBagVoucher = async (fieldVoucher, pharmacy) => {
		let returnResponse
		const urlSearchParams = new URLSearchParams(window.location.search)
		const query = Object.fromEntries(urlSearchParams.entries())

		let validVoucher

		if (!fieldVoucher) {
			if (query.voucher) {
				localStorage.setItem('validVoucher', query.voucher)
			}
			validVoucher = query.voucher ? query.voucher : localStorage.getItem('validVoucher')
		} else {
			validVoucher = fieldVoucher
		}

		if (validVoucher) {
			const response = await ServiceBagVoucher(validVoucher)
			if (response && response.pharmacy && response.pharmacy !== '') {
				let pharmacies = response.pharmacy.split(',')
				let vouchers = {}
				pharmacies.forEach((item) => {
					if (fieldVoucher && pharmacy === item) {
						vouchers = { [item]: response.code_voucher }
					} else if (!fieldVoucher) {
						vouchers = { ...vouchers, [item]: response.code_voucher }
					}
				})
				returnResponse = vouchers
			} else returnResponse = {}
		} else {
			returnResponse = {}
		}
		setGlobal(() => ({ bagVoucherPharmacies: returnResponse }))
		return returnResponse
	}
	return {
		handleBagVoucher,
	}
}
